var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailymotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0366 21.833C14.0833 22.7969 12.8888 23.2782 11.4516 23.2782C10.0384 23.2782 8.86786 22.8089 7.93862 21.869C7.00804 20.9278 6.54276 19.7172 6.54276 18.236C6.54276 16.8255 7.02004 15.6563 7.97328 14.7284C8.92652 13.7991 10.0984 13.3352 11.4876 13.3352C12.4288 13.3352 13.2834 13.5525 14.0474 13.9884C14.8126 14.4231 15.4072 15.015 15.8312 15.7683C16.2551 16.5202 16.4671 17.3428 16.4671 18.236C16.4671 19.6705 15.9898 20.8691 15.0366 21.833ZM16.1498 2.01628V10.1968C15.3259 9.37422 14.4486 8.78095 13.5181 8.41698C12.5888 8.05169 11.5463 7.87037 10.393 7.87037C8.53323 7.87037 6.86006 8.32766 5.37754 9.2449C3.89502 10.1621 2.74046 11.414 1.91654 13.0005C1.09396 14.5857 0.680664 16.3442 0.680664 18.272C0.680664 20.2452 1.08729 22.0276 1.89921 23.6142C2.71246 25.2007 3.86568 26.4525 5.36021 27.3698C6.85339 28.2857 8.56789 28.7443 10.4984 28.7443C13.3008 28.7443 15.2552 27.8271 16.3618 25.9939H16.4325V28.5003H22.0119V0.74707L16.1498 2.01628Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailymotion);
export default __webpack_public_path__ + "static/media/dailymotion.7bf95dd509cb820d4fd6f49ca59e60cd.svg";
export { ForwardRef as ReactComponent };